import React from 'react';

const WarningIcon: React.FC = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="48px"
    height="48px"
    viewBox="200 0 560 560"
    enableBackground="new 200 0 560 560"
    xmlSpace="preserve"
  >
    <g>
      <g>
        <g>
          <g>
            <path
              fill="#9B9FA6"
              d="M480,11.7c148.2,0,268.3,120.2,268.3,268.3S628.2,548.3,480,548.3S211.7,428.2,211.7,280
            S331.8,11.7,480,11.7 M480,0C326,0,200,126,200,280s126,280,280,280s280-126,280-280S634,0,480,0L480,0z"
            />
          </g>
        </g>
      </g>
    </g>
    <g>
      <rect x="468.3" y="128.3" fill="#9B9FA6" width="23.3" height="221.7" />
    </g>
    <g>
      <circle fill="#9B9FA6" cx="480" cy="396.7" r="11.7" />
    </g>
  </svg>
);

export default WarningIcon;
